module.exports = __webpack_public_path__ + "static/media/Buildings.225d0a65.svg";